// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__VEQCA","modal":"Modal_modal__Opx6J"};